import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { Pagination } from "~app/modules/catalog/models/pagination.model";

export class PLPPaginationShowMoreClickEvent implements ApplicationEvent {

  type = ApplicationEventType.PLPPaginationShowMoreClick;

  constructor(
    private pagination: Pagination,
    private defaultLimit: number,
    private defaultOffset?: number) {
  }

  getPayload(): any {
    return {
      pagination: this.pagination,
      defaultLimit: this.defaultLimit,
      defaultOffset: this.defaultOffset
    };
  }
}
